import script from "./UserFormSection.vue?vue&type=script&setup=true&lang=js"
export * from "./UserFormSection.vue?vue&type=script&setup=true&lang=js"

import "./UserFormSection.vue?vue&type=style&index=0&id=586a62a4&lang=scss&scoped=true"

import exportComponent from "/home/dev/g-nti/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-586a62a4"]])

export default __exports__